module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rotatoscope-container"
  }, [_c('div', {
    ref: "content",
    staticClass: "rotatoscope-content"
  }, [_vm._t("default"), _vm._v(" "), _vm._m(0)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "axes"
  }, [_c('div', {
    staticClass: "x-axis"
  }), _vm._v(" "), _c('div', {
    staticClass: "y-axis"
  }), _vm._v(" "), _c('div', {
    staticClass: "z-axis"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd3afc8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/rotatoscope.vue
// module id = 34
// module chunks = 0